$( window ).on( "load", function() {
  const swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2,
    spaceBetween: 0,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      }
    }
  });
  $("#announcement-bar p button").click(function() { 
    var currentAnnouncement = $(this).attr("data-announcement-id");
    $("#"+currentAnnouncement).show();
    $("html").addClass("popup-triggered");
    $(".announcement-close-button").click(function() { 
      $(".single-announcement-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
    $(".tap-area").click(function() { 
      $(".single-announcement-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $("section#shopify-section-template--17014551019716__impact_text_w4ijyw button.button.button--xl").click(function() {
    $(".google-reviews-popup-wrapper").show();
    $("html").addClass("popup-triggered");
    $(".google-reviews-close-popup").click(function() {
      $(".google-reviews-popup-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $(".google-reviews-popup-wrapper").click(function(e) { 
    if ($(event.target).is($(".google-reviews-popup-wrapper"))){   
      $(".google-reviews-popup-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
  var descHeight = $(".product-description-container").height();
  var specHeight = $(".product-tech-specs-container").height();
  var newHeight = (descHeight-25.59);
  if ( descHeight > specHeight ) {
    $(".specifications-wrapper").height(newHeight);
  }
  else {
    $(".specifications-wrapper").height('704px');      
  }
  $(".single-icon").click(function() {
    var currentIcon = $(this).attr("data-icon-name");
    $("#"+currentIcon).show();
    $("html").addClass("popup-triggered");
    $(".trust-widget-close-popup").click(function() {
      $(".trust-widget-popup-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $(".trust-widget-popup-wrapper").click(function(e) { 
    if ($(event.target).is($(".trust-widget-popup-wrapper"))){   
      $(".trust-widget-popup-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
  $(".single-announcement-wrapper").click(function(e) { 
    if ($(event.target).is($(".single-announcement-wrapper"))){   
      $(".single-announcement-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
  var descHeight = $(".product-info__description").height();
  if (descHeight > 500) {
    $(".product-info__description").addClass("collapse-content");
    $(".continue-reading").addClass("is-active");
  }
  $(".continue-reading.is-active").click(function(e) { 
    $(".product-info__description").removeClass("collapse-content");
    $(this).removeClass("is-active");
    $(".collapse-reading").addClass("is-active"); 
    $(".collapse-reading.is-active").click(function(e) { 
      $(".product-info__description").addClass("collapse-content");
      $(this).removeClass("is-active");
      $(".continue-reading").addClass("is-active"); 
    });
  });
  jQuery('.slideshow__slides-container').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000
  });
  $(".block-swatch, .color-swatch").click(function(){
    setTimeout(function() {
var currentPrice = parseInt($('sale-price.text-lg').text().replace(/[^0-9.]/g, ""));
      var grabPrice = currentPrice/4;
      $(".product .grab-price").html("S$"+grabPrice);
      var atomePrice = (currentPrice/3).toFixed(2);
      $(".product .atome-price").html("S$"+atomePrice);
    }, 2);
  });
});